var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.99989 3.99961V5.99961M5.99989 7.99961H6.00489M5.14489 1.42961L0.909888 8.49961C0.822572 8.65083 0.776372 8.82226 0.775883 8.99687C0.775394 9.17148 0.820634 9.34318 0.907102 9.49488C0.993569 9.64657 1.11825 9.77299 1.26874 9.86154C1.41923 9.95009 1.59029 9.9977 1.76489 9.99961H10.2349C10.4095 9.9977 10.5805 9.95009 10.731 9.86154C10.8815 9.77299 11.0062 9.64657 11.0927 9.49488C11.1791 9.34318 11.2244 9.17148 11.2239 8.99687C11.2234 8.82226 11.1772 8.65083 11.0899 8.49961L6.85489 1.42961C6.76575 1.28267 6.64025 1.16117 6.49049 1.07686C6.34072 0.992538 6.17176 0.948242 5.99989 0.948242C5.82802 0.948242 5.65905 0.992538 5.50929 1.07686C5.35953 1.16117 5.23402 1.28267 5.14489 1.42961Z",
    stroke: "#DC6803",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alertTriangle.96fd7a636ff64f343047cd29185b66b2.svg";
export { ForwardRef as ReactComponent };